<template>
  <div>
    <md-table v-model="donorsList" :table-header-color="tableHeaderColor">
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell md-label="Name">{{ item.partial_user.name }}</md-table-cell>
        <md-table-cell md-label="Phone">{{ item.partial_user.phone_number }}</md-table-cell>
        <md-table-cell md-label="Blood Group">{{ item.blood_group.blood_group }}</md-table-cell>
        <md-table-cell md-label="Gender">{{ item.gender.gender }}</md-table-cell>
        <md-table-cell md-label="Action"><button class="sendRequest"><span>Send Request</span></button></md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>

<script>
  var moment = require('moment');
  export default {
    name: 'simple-table',
    props: {
      tableHeaderColor: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        selected: [],
        donorsList: []
      }
    },
    beforeMount: function () {
      this.donorsList = JSON.parse(localStorage.getItem('donor_sorting_list'))
      console.log(this.donorsList)
    }
  }
</script>
<style scoped>
  .sendRequest {
    border-radius: 4px;
    background-color: #4caf50 !important;
    padding: 5px;
    width: auto;
    border: none;
    color: #FFFFFF;
    text-align: center;
    font-size: 16px;
    cursor: pointer;
    margin: 5px;
    margin-right: 10px;

  }



</style>
